import getSearchParam from '@newswebsiteapp/shared/lib/getSearchParam'
import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'

import showAndSetupModal from './lib/showAndSetupModal'

controllerLoadedObservableFactory('profile_payment_methods').subscribe(
  async () => {
    const open_verification_modal_for_bank_account_base_64_json =
      getSearchParam(
        'open_verification_modal_for_bank_account',
        window.location.href,
      )

    if (!open_verification_modal_for_bank_account_base_64_json) {
      return
    }

    const open_verification_modal_for_bank_account_json = atob(
      open_verification_modal_for_bank_account_base_64_json,
    )

    // console.log('open_verification_modal_for_bank_account_json', { open_verification_modal_for_bank_account_base_64_json, open_verification_modal_for_bank_account_json })

    let open_verification_modal_for_bank_account
    try {
      open_verification_modal_for_bank_account = JSON.parse(
        open_verification_modal_for_bank_account_json,
      )
    } catch (e) {
      console.warn(e)
      return
    }

    if (!open_verification_modal_for_bank_account) {
      return
    }

    showAndSetupModal({
      bank_account: open_verification_modal_for_bank_account.bank_account,
      customer_id: open_verification_modal_for_bank_account.customer_id,
    })
  },
)

controllerLoadedObservableFactory('profile_payment_methods').subscribe(
  async () => {
    $('[data-bank-account-add-button]').click(function () {
      const buttonAttachedData = $(this).data('bank-account-add-button')

      showAndSetupModal({
        bank_account: buttonAttachedData.bank_account,
        customer_id: buttonAttachedData.customer_id,
      })
    })
  },
)
